import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center justify-between pr-2 mb-6" }
const _hoisted_2 = { class: "flex flex-row text-xl font-semibold" }
const _hoisted_3 = {
  key: 1,
  class: "text-xl font-semibold"
}
const _hoisted_4 = { class: "flex items-center space-x-4 text-normal" }
const _hoisted_5 = { class: "flex items-center space-x-2" }
const _hoisted_6 = {
  key: 0,
  class: "font-semibold"
}

import { useDebounceFn } from "@vueuse/core";
	// Déclaration des événements que le composant peut émettre
	
export default /*#__PURE__*/_defineComponent({
  __name: 'AppWorkspaceHeader',
  props: {
		title: {
			type: String,
			default: "Title of Wokspace",
		},
		titleFilterSection: {
			type: String,
			default: "Filtre | ",
		},
		labelBackButton: {
			type: String,
			default: "Back Button",
		},
		searchbar: {
			type: Object,
			default: {
				enable: false,
				placeholder: "",
				css:
					"bg-secondary border-secondary text-white px-4 py-2 hover:bg-secondary-700 w-full active:bg-secondary-800  focus:outline-none ",
				icon: "",
				callback: () => {
					// Code here
				},
			},
		},
		btn_1: {
			type: Object,
			default: {
				enable: false,
				text: "",
				css:
					"bg-secondary border-secondary text-white px-4 py-2 hover:bg-secondary-700 w-full active:bg-secondary-800  focus:outline-none ",
				icon: "",
				callback: () => {
					// Code here
				},
			},
		},
		btn_2: {
			type: Object,
			default: {
				enable: false,
				text: "",
				css:
					"bg-secondary border-secondary text-white px-4 py-2 hover:bg-secondary-700 w-full active:bg-secondary-800  focus:outline-none ",
				icon: "",
				callback: () => {
					// Code here
				},
			},
		},
		btn_3: {
			type: Object,
			default: {
				enable: false,
				text: "",
				css:
					"bg-secondary border-secondary text-white px-4 py-2 hover:bg-secondary-700 w-full active:bg-secondary-800  focus:outline-none ",
				icon: "",
				callback: () => {
					// Code here
				},
			},
		},
		dotactions: {
			type: Object,
			default: {
				enable: false,
				options: [],
				callback: () => {
					// Code here
				},
			},
		},
		backButton: {
			type: Boolean,
			default: false,
		},
		enableFilterSection: {
			type: Boolean,
			default: false,
		},
		backButtonAction: {
			type: Function,
			default: () => {
				// Code here
			},
		},
	},
  emits: ["search-model"],
  setup(__props, { emit: __emit }) {


	const emit = __emit;

	const props = __props;

const emitSearchbarDataEventsWithDebounce = useDebounceFn((e) => {
	emit('search-model', e);
}, 1000)


return (_ctx: any,_cache: any) => {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_AdvancedSearchbar = _resolveComponent("AdvancedSearchbar")!
  const _component_ButtonTag = _resolveComponent("ButtonTag")!
  const _component_MoreActionsTag = _resolveComponent("MoreActionsTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.backButton)
        ? (_openBlock(), _createBlock(_component_BackButton, {
            key: 0,
            label: __props.labelBackButton,
            onClick: __props.backButtonAction,
            css: "h-6 w-6",
            class: "flex"
          }, null, 8, ["label", "onClick"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.title), 1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (__props.enableFilterSection)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.titleFilterSection), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "filter")
      ]),
      (__props.searchbar.enable)
        ? (_openBlock(), _createBlock(_component_AdvancedSearchbar, {
            key: 0,
            placeholder: __props.searchbar.placeholder,
            onClick: __props.searchbar.callback,
            css: __props.searchbar.css,
            icon: __props.searchbar.icon,
            onModel: _cache[0] || (_cache[0] = (e) => _unref(emitSearchbarDataEventsWithDebounce)(e))
          }, null, 8, ["placeholder", "onClick", "css", "icon"]))
        : _createCommentVNode("", true),
      (__props.btn_1.enable)
        ? (_openBlock(), _createBlock(_component_ButtonTag, {
            key: 1,
            label: __props.btn_1.text,
            onClick: __props.btn_1.callback,
            css: __props.btn_1.css,
            activeIcon: true,
            icon: __props.btn_1.icon,
            id: "newButtonOperation",
            iconStyle: __props.btn_1.iconStyle
          }, null, 8, ["label", "onClick", "css", "icon", "iconStyle"]))
        : _createCommentVNode("", true),
      (__props.btn_2.enable)
        ? (_openBlock(), _createBlock(_component_ButtonTag, {
            key: 2,
            label: __props.btn_2.text,
            onClick: __props.btn_2.callback,
            css: __props.btn_2.css,
            activeIcon: true,
            icon: __props.btn_2.icon,
            iconStyle: __props.btn_2.iconStyle
          }, null, 8, ["label", "onClick", "css", "icon", "iconStyle"]))
        : _createCommentVNode("", true),
      (__props.btn_3.enable)
        ? (_openBlock(), _createBlock(_component_ButtonTag, {
            key: 3,
            label: __props.btn_3.text,
            onClick: __props.btn_3.callback,
            css: __props.btn_3.css,
            activeIcon: true,
            icon: __props.btn_3.icon,
            iconStyle: __props.btn_3.iconStyle
          }, null, 8, ["label", "onClick", "css", "icon", "iconStyle"]))
        : _createCommentVNode("", true),
      (__props.dotactions?.enable ?? false)
        ? (_openBlock(), _createBlock(_component_MoreActionsTag, {
            key: 4,
            options: __props.dotactions.options,
            onClick: (data, clickedOptionName,  clickedOptionSubName) => __props.dotactions.callback(data, clickedOptionName),
            styleSubMenu: "left-[-125px]",
            data: {}
          }, null, 8, ["options", "onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})